<template>
  <div class="download">
    <div class="item1">
      <img :src="logoUrl" class="app-logo" />
    </div>
    <div class="item2">
      <div class="t1">橙鹿APP</div>
      <div class="t2">用最快的速度拿到正规学历</div>
    </div>
    <div class="item3">
      <img class="item-icon" src="../assets/img/and.png" alt="and" />
      <span class="t3"><a :href="androidUrl" target="_blank" class="download-link">下载</a></span>
    </div>
    <!--<div class="item4">
      <img class="item-icon" src="../assets/img/ios.png" alt="and" />
      <span class="t3"><a :href="iosUrl" target="_blank" class="download-link">下载</a></span>
    </div>-->
    <img
      @click="closeFn()"
      class="close"
      src="../assets/img/icon_colse.png"
      alt="close"
    />
  </div>
</template>

<script>
import logoImg from '@/assets/img/applogo.png';
export default {
  name: 'download',
  data() {
    return {
      logoUrl: logoImg,
      androidUrl: 'https://xlb-app.chengluedu.net/app-clxlb.apk',
      iosUrl: ''
    };
  },
  methods: {
    closeFn() {
      this.$parent.isShow = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// @import '@/assets/css/color.scss';
.download {
  background-color: #fff;
  font-size: 24px;
  color: #06112a;
  width: 100%;
  display: flex;
  height: 152px;
  position: fixed;
  bottom: 0;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
}
.close {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 18px;
  right: 18px;
}
.item1 {
  width: 88px;
  height: 88px;
  border-radius: 12px;
}
.item2 {
  width: 359px;
  margin-left: 15px;
}
.t1 {
  font-size: 30px;
  font-weight: bold;
  color: #06112a;
  line-height: 36px;
  padding-top: 8px;
}
.t2 {
  font-size: 26px;
  font-weight: 500;
  color: #6d7581;
  line-height: 36px;
}
.item3,
.item4 {
  width: 88px;
  height: 88px;
  border-radius: 12px;
  color: #fff;
}
.item3 {
  background-color: #fa841a;
}
.item4 {
  margin-left: 20px;
  background-color: #545459;
}
.item-icon {
  display: block;
  height: 30px;
  margin: 15px auto 0;
}
.t3 {
  display: block;
  text-align: center;
  font-size: 20px;
  transform: scale(0.75);
  line-height: 42px;
}
.download-link{
  color: #fff;
}
.app-logo {
  width: 88px;
  height: 88px;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue